import {
  notificationRuleReferenceQuery,
  notificationRulesQuery,
} from "@common/api"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { JsonReference } from "./-components/json-document/reference"
import { NotificationRulesForm } from "./-components/notification-rules/form"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/notification-rules",
)({
  staticData: { breadcrumb: "Notification Rules" },
  loader: ({ context: { queryClient }, params }) =>
    Promise.all([
      queryClient.ensureQueryData(
        notificationRulesQuery({ tenant_id: params.tenantId }),
      ),
      queryClient.ensureQueryData(
        notificationRuleReferenceQuery({ tenant_id: params.tenantId }),
      ),
    ]),
  component: NotificationRulesTab,
})

function NotificationRulesTab(): React.ReactElement {
  const { tenantId } = Route.useParams()
  const showToast = useCustomToast()
  const { data: rules } = useSuspenseQuery(
    notificationRulesQuery({ tenant_id: tenantId }),
  )
  const { data: reference } = useSuspenseQuery(
    notificationRuleReferenceQuery({ tenant_id: tenantId }),
  )

  return (
    <div className="space-y-6">
      <NotificationRulesForm
        tenantId={tenantId}
        rules={rules}
        onSave={() => showToast("Saved", "Notification rules saved", "success")}
      />
      <JsonReference
        title="Reference: events, people and the rule schema"
        reference={reference}
      />
    </div>
  )
}
